// The Job # box of a quotation line (Calem, reports a41d2a8b + 8cdf896a), read the same way as parseSeq in
// server/src/services/jobsService.ts, which has the last word: 0 = no Job; 1, 2, 1.a … = a Job (1 = the main Job,
// 2 = the next follow-up Job, which waits for Job # 1; a letter merges lines into one Job); -1, -2 … = the dependency
// of Job # 1, 2 …, its own Job that completes and closes with it. Shared by the quotation form (Peak/InvoiceForm.tsx)
// and the quotation-services pop-up on Active Jobs, where an administrator corrects a line's Job #.

// The box only takes digits, '.', a-z and '-'.
export const sanitizeSeq = (v: string) => v.toLowerCase().replace(/[^0-9a-z.-]/g, '');

// A blank or unreadable code ("a", "1.", "1.2", "-0") would make no Job. A minus number must be 1 or more.
export const isJobSeqCode = (v?: string) => /^(?:-\d*[1-9]\d*|\d+(?:\.[a-z]+)?)$/.test(String(v || '').trim().toLowerCase());

// Coded 0 (or 0.a …): the line makes no Job — a government fee or disbursement, not work the firm carries out
// (lineHasNoJob on the server). Blank is NOT 0.
export const isNoJobSeq = (v?: string) => /^0+(?:\.[a-z]+)?$/.test(String(v || '').trim().toLowerCase());
